"use strict";

import React from 'react';
import PropTypes from 'prop-types';
import AuthActions from '../actions/AuthActions';
import Config from '../lib/Config';
import MigrationStore from '../stores/MigrationStore';
import {getStoredMigrationRedirectUrl, isMigrationCompleted} from '../lib/migrationUtils';
import Button from './ui/Button.react';

/**
 * Leaves the migration flow. Shared by the Web 9 "Exit" and Web 10 "Back"
 * buttons, which carry different labels and part ways on destination:
 *
 * - transfer complete (Web 9): on to Rakuten TV's origin (scheme + host),
 *   taken from the migrate hand-off URL, or Config.RAKUTEN_TV_WEB_URL when
 *   there is none. Path and query from the hand-off are dropped on purpose.
 * - anything else (Web 10): sign out only, as every other sign-out control in
 *   the app does, so AppContainer routes the user to the sign-in page.
 */
export default class MigrationExitButton extends React.Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
    };

    state = {
        pending: false,
    };

    _onClick = () => {
        if (this.state.pending) {
            return;
        }
        this.setState({pending: true});

        // Resolve the destination first: signing out clears the migration status.
        const migrationStatus = MigrationStore.migrationStatus;
        const redirectUrl = isMigrationCompleted(migrationStatus)
            ? (getStoredMigrationRedirectUrl(migrationStatus.userName) || Config.RAKUTEN_TV_WEB_URL)
            : null;

        AuthActions.signOutUser();

        if (redirectUrl) {
            try {
                window.location.assign(new URL(redirectUrl).origin);
            } catch (error) {
                window.location.assign(Config.RAKUTEN_TV_WEB_URL);
            }
        }
    };

    render() {
        return (
            <div className="migration-outcome-overlay__actions migration-outcome-overlay__actions--single migration-outcome-overlay__actions--centered">
                <Button
                    type="button"
                    shape="square"
                    className="cta-play full-width"
                    disabled={this.state.pending}
                    updatePending={this.state.pending}
                    onClick={this._onClick}
                >
                    {this.props.label}
                </Button>
            </div>
        );
    }
}
